import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  input,
  signal,
  WritableSignal,
} from '@angular/core';
import { Message } from 'primeng/message';
import { Beneficjent } from '../../models/beneficjent';
import { UserApi } from '../../services/api/user.api';
import { catchError, EMPTY, finalize, interval, takeWhile, tap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { HttpResponseService } from '../../../core/services/http-error-response.service';

@Component({
  selector: 'app-email-verify-info',
  imports: [Message],
  templateUrl: './email-verify-info.html',
  styleUrl: './email-verify-info.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmailVerifyInfo {
  public beneficiary = input.required<Beneficjent>();
  readonly #userApi = inject(UserApi);
  readonly #httpResponseService = inject(HttpResponseService);
  readonly #destroyRef = inject(DestroyRef);

  readonly isSending = signal(false);
  // sygnał blokady przycisku
  readonly isCooldown: WritableSignal<boolean> = signal(false);
  // opcjonalnie: ile sekund zostało
  readonly cooldownLeft: WritableSignal<number> = signal(0);

  protected sendVerificationLink(): void {
    if (this.isSending() || this.isCooldown()) {
      return;
    }

    this.isSending.set(true);

    this.#userApi
      .verifyEmail$()
      .pipe(
        takeUntilDestroyed(this.#destroyRef),
        tap(() => {
          this.startCooldown(60);
          this.#httpResponseService.showSuccessMessage(
            'Link weryfikujący został wysłany',
          );
        }),
        catchError((err) => {
          this.#httpResponseService.showErrorMessage(
            err,
            'Nie udało się wysłać linku weryfikującego adres e-mail. Spróbuj ponownie za kilka minut.',
          );
          this.isCooldown.set(false);
          this.cooldownLeft.set(0);
          return EMPTY;
        }),
        finalize(() => this.isSending.set(false)),
      )
      .subscribe();
  }

  startCooldown(seconds: number): void {
    this.cooldownLeft.set(seconds);
    this.isCooldown.set(true);
    interval(1000)
      .pipe(
        tap(() => this.cooldownLeft.update((v) => v - 1)),
        takeWhile(() => this.cooldownLeft() > 0),
        takeUntilDestroyed(this.#destroyRef),
        finalize(() => this.isCooldown.set(false)),
      )
      .subscribe();
  }
}
